import * as React from 'react'
import { translateCountryName } from "@ui-seeker/utils"

import {RetailerBlock} from "@components";


export default function retailerColumn() {
    return [{
        name: 'country', label: 'Country',
        options: {
            display: 'excluded',
            customBodyRowRender: v => translateCountryName(v)
        }
    },{
        name: 'siteName', label: 'Retailer',
        options: {
            headerAlign: 'left',
            customBodyRowRenderLite: (value, { country, siteURL }) => <RetailerBlock
                retailer={value}
                country={country}
                siteURL={siteURL}
            />
        }
    }]
}